import type { IBlog } from "@/lib/types/blog"
import type { CourseDetail } from "@/lib/types/course/detail"
import type { BlogDetail } from "@/lib/types/blog/detail"

export interface ICartData {
	id: number
	[key: string]: any
}

export interface BaseListItemProps {
	data?: CourseDetail | BlogDetail | any
	type?: "cart" | "course" | "blog"
	refetch?: () => void
	cartData?: ICartData
	showPercentLearned?: boolean
	showWhiteList?: boolean
}

export interface CourseListItemProps extends BaseListItemProps {
	data: CourseDetail
}

export interface BlogListItemProps extends BaseListItemProps {
	data: IBlog
}

export const isBlog = (data: CourseDetail | IBlog): data is IBlog => {
	return (data as IBlog).user_fullname !== undefined
}

export const isCourse = (data: CourseDetail | IBlog): data is CourseDetail => {
	return (data as CourseDetail).course_objective !== undefined
}
